<template>
  <div class="lista__menu">
    <div>
      <BarraLateralLogo />
      <BarraLateralItem
        v-for="rota in retornaRotas()"
        :key="rota.modulo"
        :rotas="rota"
        @clicouItemMenu="clicouItemMenuMethod" />
    </div>
    <div>
      <BarraLateralBotao
        label="Sair"
        icon="power-off"
        @onClick="realizaLogout" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AutorizacaoRotas from '@/models/AutorizacaoRotas'

import BarraLateralLogo from './BarraLateralLogo.vue'
import BarraLateralItem from './BarraLateralItem.vue'
import BarraLateralBotao from './BarraLateralBotao.vue'

import rotas from '@/modules/rotas'

export default {
  name: 'BarraLateral',
  components: {
    BarraLateralLogo,
    BarraLateralItem,
    BarraLateralBotao,
  },
  created() {
    this.retornaRotas()
  },
  methods: {
    ...mapActions('autenticacao', ['sairDoSistemaStore']),
    clicouItemMenuMethod() {
      this.$emit('clicouItemMenu')
    },
    retornaRotas() {
      const possuemRotasMenu = rotas.filter(modulo => modulo.mostrarMenu
        && AutorizacaoRotas.podeMostrarModulo(modulo.cargos))

      return possuemRotasMenu.map(modulo => (
        {
          label: modulo.label,
          modulo: modulo.modulo,
          icon: modulo.icon,
          rotas: modulo.rotas.filter(item => item.menu
            && AutorizacaoRotas.podeLiberarRota(item.cargo)),
        }
      ))
    },
    realizaLogout() {
      this.sairDoSistemaStore()
      location.reload()
    },
  },
}

</script>

<style lang="scss" scoped>
@import '@/scss/breakpoints.scss';
@import '@/scss/colors.scss';

.lista__menu {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  padding-bottom: .5rem;
}

</style>
